import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=989fd5d4&scoped=true&"
import script from "./UiCard.vue?vue&type=script&lang=js&"
export * from "./UiCard.vue?vue&type=script&lang=js&"
import style0 from "./UiCard.vue?vue&type=style&index=0&id=989fd5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989fd5d4",
  null
  
)

export default component.exports